<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>
    <!-- 1 -->
    <input-form-penilaian
      :tables="tableInput.inputForm1"
      :listInput="listInput.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview"
    />
    <desc-penilaian
      :tables="tableDesc.inputForm1"
      :listInput="listDesc.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="true"
    />

    <block-label :label="'1. KEBIJAKAN, KEPEMIMPINAN & KOMITMEN'" />
    <plain-label
      :label="
        'Berikan penjelasan rinci mengenai komitmen pimpinan melalui Kebijakan Kesehatan, Keselamatan Kerja dan Lingkungan (K3L) dan Kebijakan Khusus lainnya di perusahaan Anda.'
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGrup1'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan bukti dokumen kebijakan K3L & Kebijakan Khusus (Kebijakan Mutu, Kebijakan Larangan Narkotika, Minuman Beralkohol, Merokok dan Pencegahan HIV-AIDS, Kebijakan SR, dll'
      "
    />
    <upload-file
      :modelName="'kebijakanFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :docId="4"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan bukti implementasi dokumen kebijakan K3L & Kebijakan Khusus kepada karyawan (Minimal 3 Bukti dalam 1 Dokumen, contoh: Sosialisasi, Form absensi sesuai materi dan Foto dokumentasi)'
      "
    />
    <upload-file
      :modelName="'buktiKebijakanFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="5"
    />
    <!-- 2 -->
    <input-form-penilaian
      :tables="tableInput.inputForm2"
      :listInput="listInput.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview"
    />
    <desc-penilaian
      :tables="tableDesc.inputForm2"
      :listInput="listDesc.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="true"
    />

    <block-label :label="'2. MANAJEMEN RISIKO'" />
    <plain-label
      :label="
        'Berikan penjelasan rinci pengaturan mengenai pengelolahan Manajemen Risiko (HIRA) di perusahaan anda'
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGrup2'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label :label="'Lampirkan SOP HIRA & matriks penilaian risiko'" />
    <upload-file
      :modelName="'hiraFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :docId="6"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan bukti statement/policy mengenai perlunya melakukan penilaian bahaya K3 dan lingkungan, dan memiliki prosedur yang jelas mekanisme pengaturan penilaian bahaya/risk Assesment/HIRA/IBPR'
      "
    />
    <upload-file
      :modelName="'policyFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :docId="7"
      :disabled="true"
    />
    <!-- 2.2 -->
    <plain-label
      :label="
        'Berikan penjelasan inti mengenai aktifitas/kegiatan apa saja yang telah dilakukan Analisis Risiko (HIRA) dan Analisa Kesehatan (JSA) berikut pengendaliannya'
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGrup22'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan, revisi terbaru dan terdapat persetujuan manajemen'
      "
    />
    <upload-file
      :modelName="'riskFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="8"
    />
    <plain-label
      :label="
        'Lampirkan bukti implementasi sosialisasi risk assessment /HIRA/IBPR kepada pekerja (Form absensi dan Foto Dokumentasi)'
      "
    />
    <upload-file
      :modelName="'implementasiRiskFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="9"
    />
    <!-- 3 -->
    <input-form-penilaian
      :tables="tableInput.inputForm3"
      :listInput="listInput.inputForm3"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview"
    />
    <desc-penilaian
      :tables="tableDesc.inputForm3"
      :listInput="listDesc.inputForm3"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="true"
    />
    <block-label :label="'3. MANUAL K3L'" />
    <plain-label
      :label="
        'Berikan penjelasan rinci mengenai Manual atau Pedoman Sistem Pengelolaan K3L sesuai lingkup operasional perusahaan'
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGrup3'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan dokumen Manual Keselamatan Kerja, Kesehatan, dan Perlingdungan Lingkungan yang telah disetujui oleh manajemen'
      "
    />
    <upload-file
      :modelName="'manualFile'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="10"
    />
    <plain-label
      :label="
        'Lampirkan bukti implementasi sosialisasi Manual K3L/SMK3L kepada pekerja (Form absensi dan Foto Dokumentasi)'
      "
    />
    <upload-file
      :modelName="'implementasiManual'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="11"
    />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan & Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFormPenilaian from '../../components/forms/input-form-penilaian.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFormPenilaian,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
        inputForm2: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
        inputForm3: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'label',
            label: 'KEBIJAKAN, KEPEMIMPINAN DAN KOMITMEN',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup1_11',
            inputStore: 'note_grup1_11',
          },
        ],
        inputForm2: [
          {
            type: 'label',
            label: 'MANAJEMEN RISIKO',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup2_11',
            inputStore: 'note_grup2_11',
          },
          {
            type: 'form',
            name: 'ITEM 1.2',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup2_12',
            inputStore: 'note_grup2_12',
          },
        ],
        inputForm3: [
          {
            type: 'label',
            label: 'MANUAL K3L',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup3_11',
            inputStore: 'note_grup3_11',
          },
        ],
      },
      tableDesc: {
        inputForm1: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm2: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm3: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
      },
      listDesc: {
        inputForm1: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'KEBIJAKAN, KEPEMIMPINAN DAN KOMITMEN',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  '1. Tidak ada dokumen kebijakan K3L dan kebijakan khusus lainnya (Kebijakan Mutu, Kebijakan Larangan Narkotika, Minuman Beralkohol, Merokok dan Pencegahan HIV-AIDS, Kebijakan SR, dll).',
                desc_3: [
                  '1. Terdapat bukti dokumen kebijakan K3L dan kebijakan khusus (Kebijakan Mutu, Kebijakan Larangan Narkotika, Minuman Beralkohol, Merokok dan Pencegahan HIV-AIDS, Kebijakan SR, dll).',
                  '2. Disetujui oleh pimpinan tertinggi di perusahaan sesuai struktur organisasi',
                ],
                desc_4: [
                  '1. Terdapat bukti dokumen kebijakan K3L dan kebijakan khusus (Kebijakan Mutu, Kebijakan Larangan Narkotika, Minuman Beralkohol, Merokok dan Pencegahan HIV-AIDS, Kebijakan SR, dll).',
                  '2. Disetujui oleh pimpinan tertinggi di perusahaan sesuai struktur organisasi',
                  '3. Terdapat bukti, kebijakan perusahaan disebarluaskan dan dikomunikasikan kepada seluruh karyawan, tamu dan kontraktor di perusahaan.',
                ],
              },
            ],
          },
        ],
        inputForm2: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'MANAJEMEN RISIKO',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2: '1. Tidak ada SOP HIRA dan Matriks penilaian risiko.',
                desc_3: '1. Terdapat SOP HIRA dan Matriks penilaian risiko.',
                desc_4: [
                  '1. Terdapat SOP HIRA dan Matriks penilaian risiko.',
                  '2. Ada bukti statement/policy mengenai perlunya melakukan penilaian bahaya k3 dan lingkungan, dan memiliki prosedur yang jelas mekanisme pengaturan penilaian bahaya/Risk Assessment/HIRA/IBPR.',
                ],
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.2',
                desc_2:
                  '1. Tidak terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
                desc_3:
                  '1. Terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
                desc_4: [
                  '1. Terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
                  '2. Bukti implementasi dokumen risk assessment/HIRA/IBPR kepada pekerja.',
                ],
              },
            ],
          },
        ],
        inputForm3: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'MANUAL K3L',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  '1. Tidak ada dokumen Manual Keselamatan Kerja, Kesehatan dan Perlindungan Lingkungan.',
                desc_3:
                  '1. Terdapat dokumen Manual Keselamatan Kerja, Kesehatan dan Perlindungan Lingkungan.',
                desc_4: [
                  '1. Terdapat dokumen Manual Keselamatan Kerja, Kesehatan dan Perlindungan Lingkungan.',
                  '2. Bukti implementasi dokumen Manual K3L kepada karyawan yang mencakup pekerjaan-pekerjaan kritis yang dilakukan.',
                ],
              },
            ],
          },
        ],
      },
    }
  },
  async created() {
    await this.$store.commit('k3lStore/CALCULATION_1')
    await this.$store.commit('k3lStore/CALCULATION_2')
    await this.$store.commit('k3lStore/CALCULATION_3')
  },
  watch: {
    '$store.state.k3lStore.penilaian_grup1_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup2_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup2_12'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup3_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'dokumentasi' })
    },
    goNext() {
      if (this.$get(this.$store, 'state.k3lStore.is_preview')) {
        this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
      } else {
        this.$store.commit('k3lStore/SAVE_DRAFT_SIPM_SUBMIT', {
          onSuccess: () => {
            this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
          },
        })
      }
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
